module.exports = __webpack_public_path__ + "images/help/video-permission-e9f7019d568a77329e18b33f3eee3117.png";